import { render } from "./ClaimsDocuments.vue?vue&type=template&id=20425c4b&ts=true"
import script from "./ClaimsDocuments.vue?vue&type=script&lang=ts"
export * from "./ClaimsDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__